import React, { useEffect, useState } from "react";
import Clientstab from "../component/ClientsTab";
import SearchBar from "../component/SearchBar";
import TopTitleBanner from "../component/TopTitleBanner";
import "../css/dashboard.css";
import "../css/client.css";
import { Box, Button, Menu, MenuItem, Modal } from "@mui/material";
import AddClient from "../component/forms/AddClient";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { useAuth } from "../contexts/AuthContext";
import { roles } from "../firebase.collection";
import { ViewModule, ViewList, Add } from "@mui/icons-material";
import Switch from "@mui/joy/Switch";
import AddQuickNoteWithClients from "../component/Notes/AddQuickNoteWithClients";
import { recordMetrics } from "../logsComponents/recordMetrics";
import NotesAddModal from "../component/modals/NotesAddModal";
import { incrementDailyReads } from "../logsComponents/incrementDailyReads";

export default function ClientsContent({
  filterByTherapist = false,
  title = "Clients",
  rehabFilter = null,
  initialTab = null,
}) {
  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";
  const [userRole, setUserRole] = useState("");
  const [userDisplayName, setUserDisplayName] = useState("");
  const [viewMode, setViewMode] = useState(false); // true pour les widgets, false pour la vue en ligne
  const [dark, setDark] = useState(false);
  const [anchorElNoteType, setAnchorElNoteType] = useState(null);
  const openNoteTypeMenu = Boolean(anchorElNoteType);
  const [openAddModal2, setOpenAddModal2] = useState(false);

  const [currentNoteType, setCurrentNoteType] = useState("");

  const formatNoteType = (noteType) => {
    return noteType
      .replace(/([A-Z])/g, " $1") // Ajouter un espace avant chaque lettre majuscule
      .replace(/^./, (str) => str.toUpperCase()); // Mettre la première lettre en majuscule
  };

  const handleSelectNoteType = (noteType) => {
    setCurrentNoteType(noteType);
    setOpenAddModal2(true);
    handleCloseNoteTypeMenu();
  };

  const handleCloseNoteTypeMenu = () => {
    setAnchorElNoteType(null);
  };

  const fixedNoteTypes = [
    "aftercareNote",
    "medicalNote",
    "quickNote",
    "familyNote",
    "supportStaffNote",
    "therapyNote",
    "handoverNote",
    "groupNote",
    "endOfShift",
  ];

  const handleChange = async (event) => {
    setViewMode(event.target.checked);
    setDark(event.target.checked);
  };
  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "80%",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleModalQuickNote = {
    ...styleModalGeneral, // Vous pouvez réutiliser le style de la modal générale
  };

  const [openAddClient, setOpenAddClient] = useState(false);
  const [openAddQuickNote, setOpenAddQuickNote] = useState(false);

  const handleOpenAddClient = () => {
    setOpenAddClient(true);
    // recordMetrics("Clients", "addClient", currentUser.email, "write", "bodhi");
  };

  const handleCloseAddClient = () => setOpenAddClient(false);

  const handleCloseAddQuickNote = () => setOpenAddQuickNote(false);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        try { incrementDailyReads("roles", 1); } catch {}
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const data = doc.data();
          const role = data.role;
          setUserRole(role);
          setUserDisplayName(data.displayName || "");
        } else {
          console.log("No role for this user");
        }
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
      recordMetrics("Clients", "pageLoad", currentUser.email, "read", "bodhi");
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const therapistFilter =
    filterByTherapist &&
    (userRole === "Therapist" || userRole === "Super Admin")
      ? userDisplayName || currentUser?.displayName || currentUser?.email || ""
      : null;

  return (
    <div className="right-container">
      <NotesAddModal
        open={openAddModal2}
        onClose={() => setOpenAddModal2(false)}
        // onClose={handleCloseAddNoteModal}
        noteType={currentNoteType}
        // handleSave={handleSaveNote}
      />
      <Modal
        open={openAddClient}
        onClose={handleCloseAddClient}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddClient closemodal={handleCloseAddClient} />
        </Box>
      </Modal>
      <Modal
        open={openAddQuickNote}
        onClose={handleCloseAddQuickNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalQuickNote}>
          <AddQuickNoteWithClients closemodal={handleCloseAddQuickNote} />
        </Box>
      </Modal>
      <TopTitleBanner title={title} />

      <div className="top-component-list-clients" style={{ width: "1330px" }}>
        <SearchBar />
        {(userRole === "Super Admin" || userRole === "Admission staff") && (
          <>
            <Button
              startIcon={<Add />}
              style={{
                width: "150px",
                height: "45px",
                marginRight: "20px",
                marginLeft: "20px",
              }}
              onClick={handleOpenAddClient}
              variant="outlined"
            >
              Add Client
            </Button>

            <Menu
              anchorEl={anchorElNoteType}
              open={openNoteTypeMenu}
              onClose={handleCloseNoteTypeMenu}
            >
              {/* {noteTypes.map((noteType) => ( */}
              {fixedNoteTypes.map((noteType) => (
                <MenuItem
                  key={noteType}
                  onClick={() => handleSelectNoteType(noteType)}
                >
                  {formatNoteType(noteType)}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
        <div
          style={{
            marginRight: "0px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Switch
            color={dark ? "primary" : "primary"}
            slotProps={{ input: { "aria-label": "dark mode" } }}
            startDecorator={
              <ViewModule sx={{ color: dark ? "#ababab" : "#1976d2" }} />
            }
            endDecorator={
              <ViewList sx={{ color: dark ? "#1976d2" : "#ababab" }} />
            }
            checked={dark}
            onChange={handleChange}
          />
        </div>
      </div>
      <Clientstab
        viewMode={viewMode}
        userRole={userRole}
        therapistFilter={therapistFilter}
        rehabFilter={rehabFilter}
        initialTab={initialTab}
      />
    </div>
  );
}
